export const environment = {
  production: true,
  apiRoot: "https://app.comidaqs.dk",
  oauthAppId: {
    azureBc2: {
      appId: "47e7d5aa-6353-46fb-9fae-ac1ba120a0e1",
      tenantId: "4483eca5-9d75-4dbf-8057-75670af310bc",
    },
  },
  redirectUrl: "environment.redirectUrl",
};
